import { ExamRepository } from "repositories/ExamRepository";
import { AppThunk } from "../rootStore";
import {
  setCurrentExamGroup,
  setCurrentExamGroupDoubleKnee,
  setCurrentExamGroupLeftKnee,
  setCurrentExamGroupRightKnee,
} from "./examGroupSlice";
import { addRequest, removeRequest } from "../LoadingStore/loadingSlice";
import { Requests } from "../../types/requests";

export const getExamGroup =
  (id: string, reset?: boolean, callback?: () => void): AppThunk =>
  async (dispatch) => {
    console.log("getExamGroup");
    if (reset) {
      dispatch(setCurrentExamGroup([]));
      dispatch(setCurrentExamGroupRightKnee([]));
      dispatch(setCurrentExamGroupLeftKnee([]));
      dispatch(setCurrentExamGroupDoubleKnee([]));
      return;
    }
    try {
      const examRepository = ExamRepository.getInstance();
      dispatch(addRequest(Requests.getExamGroup));
      const exam = await examRepository.getExamGroup(id);
      dispatch(setCurrentExamGroup(exam));
      dispatch(setCurrentExamGroupRightKnee([]));
      dispatch(setCurrentExamGroupLeftKnee([]));
      dispatch(setCurrentExamGroupDoubleKnee([]));
      console.log("SET EXAM GROUP");
      if (exam.length > 0) {
        exam.map((exam) => {
          if (exam.joint?.name == "knee" && exam.joint?.side == "right") {
            dispatch(setCurrentExamGroupRightKnee([exam]));
          }
          if (exam.joint?.name == "knee" && exam.joint?.side == "left") {
            dispatch(setCurrentExamGroupLeftKnee([exam]));
          }
          if (exam.joint?.name == "bothKnees") {
            dispatch(setCurrentExamGroupDoubleKnee([exam]));
          }
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(removeRequest(Requests.getExamGroup));
    }

    if (callback) {
      callback();
    }
  };
